import axios from 'axios';

// Shared axios instance used by every authenticated frontend caller.
// The 401 interceptor that handles session expiry lives in App.js as
// `ApiInterceptorSetup` — it has to mount inside <BrowserRouter> so
// it can call useNavigate() for a soft (SPA) redirect to /login.
const api = axios.create({
  timeout: 10000,
});

export default api;
